import { DriveStep, Driver } from "driver.js";
import { t } from "i18next";

export const getSteps = (driver: Driver): DriveStep[] => [
  {
    element: ".title .click-panel",
    // onHighlighted:()=>{},
    popover: {
      title: t("tour.openAgainTitle"),
      description: t("tour.openAgainDesc"),
      showButtons:["next"],
      // onNextClick:driver.moveNext
    },
  },
  {
    element: ".tour-btn",
    onHighlighted:()=>{},
    popover: {
      title: t("tour.guideButtonTitle"),
      description: t("tour.guideButtonDesc"),
      showButtons:["next"],
      onNextClick: driver.moveNext,
    },
  },
];
